export default "__VITE_ASSET__BrEaa5Ih__"